import { submitPrV2Review } from './fetch-pr-v2';

export type PullRequestTarget = { owner: string; repo: string; number: number };

/**
 * Approves a pull request as the signed-in user, with no review body and none of the pending draft
 * comments the PR page would include. For approving from outside the PR page, such as a desktop
 * notification or the tray popover.
 *
 * Pass the same `submissionId` when retrying one approval, so the server drops the retry if the
 * first attempt already reached GitHub.
 */
export async function approvePullRequest(
  { owner, repo, number }: PullRequestTarget,
  submissionId: string,
): Promise<void> {
  await submitPrV2Review(owner, repo, String(number), {
    submissionId,
    review: { comment: '', reviewType: 'APPROVE' },
    comments: [],
  });
}
